
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    standalone: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      self_active: false
    }
  },
  computed: {
    c_active () {
      return this.active || this.self_active
    }
  },
}
